/* eslint-disable react-hooks/exhaustive-deps */
// wijmo

// react
import {
  Container,
  Row,
  Col,
  Card,
  Collapse,
  Button,
  Form,
} from "react-bootstrap"
import { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."

// others
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import queryString from "query-string"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import dateUtil from "../../../ts/util/dateUtil"

// Kairos
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import DateInput from "../../../components/InputWrapper/DateInput"
import { RootState } from "../../../globalStore/rootreducer"
import TextInput from "../../../components/InputWrapper/TextInput"
import ZyutyuHaisyaListGrid from "./ZyutyuHaisyaListGrid"
import { T表紙分割 } from "../../../components/ComboBox/HyosiBunkatuComboBox"
import { T請求内訳 } from "../../../components/ComboBox/SeikyuUtiwakeComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import CheckInput from "../../../components/InputWrapper/CheckInput"
import Spinner from "../../../components/Spinner"
import { ZyutyuHaisyaListProvider } from "./ZyutyuHaisyaListContext"

import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import { 画面ロック解除 } from "../../../globalStore/progressStore"
import {
  TZyutyuHaisyaListGetReq,
  TZyutyuHaisyaListGetReqInner,
  TZyutyuHaisyaListGetRes,
} from "../../../service/order/zyutyuHaisya/TZyutyuHaisya"
import ZyutyuHaisyaService from "../../../service/order/zyutyuHaisya/zyutyuHaisyaService"
import { 区分分類コード } from "../../../constant/enum/codes"
import { e検索日種別, T検索日種別コード } from "../../../constant/enum/frontend"
import BusyoService from "../../../service/master/busyo/busyoService"
import KubunService from "../../../service/master/kubun/kubunService"
import NinusiService from "../../../service/master/ninusi/ninusiService"
import NinusiSeikyuService from "../../../service/master/ninusiseikyu/ninusiSeikyuService"
import VALIDATE_CONSTANT from "../../../constant/validateConstant"
import {
  T検索日ComboboxItem,
  T表示用検索条件,
  T表示用検索条件共通部,
} from "./TZyutyuHaisyaList"
import CONSTANT from "../../../constant"
import NinusiSearchModal from "../../../components/SearchModal/NinusiSearchModal"
import HaisyaService from "../../../service/order/haisya/HaisyaService"
import { T分割受注配車 } from "../../../service/order/haisya/THaisya"

const 検索日: T検索日ComboboxItem[] = [
  { name: "積日", value: "1" } as const,
  { name: "卸日", value: "2" } as const,
  { name: "請求計上日", value: "3" } as const,
]

/**
 * 受注配車入力
 * @returns
 */
const ZyutyuHaisyaList = () => {
  const history = useHistory()
  const location = useLocation()
  const dispatch: AppDispatch = useDispatch()

  const { LoginUserInfo: userInfo } = useSelector(
    (state: RootState) => state.user
  )

  const { yokueigyobiStr: 翌営業日 } = useSelector(
    (state: RootState) => state.date
  )

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  const [accordionController, setAccordionController] = useState(true)

  //TODO:ページ名称確定必須
  let gridId = "ZyutyuHaisyaList_GridId"

  //#region [state]

  // 画面共通
  const [isSearching, setIsSearching] = useState(false)
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()
  const [配車状態区分ItemSource, set配車状態区分ItemSource] =
    useState<T区分マスタ[]>()

  const [displaySearchCondition, setDisplaySearchCondition] =
    useState<T表示用検索条件<T検索日種別コード>>()

  const [preSearchCondition, setPreSearchCondition] =
    useState<TZyutyuHaisyaListGetReq<T検索日種別コード>>()

  const [searchResult, setSearchResult] =
    useState<(TZyutyuHaisyaListGetRes & { 分割情報?: T分割受注配車 })[]>()

  const [検索結果受注部所コード, set検索結果受注部所コード] =
    useState<string>("")

  //１列目
  const [検索日コード, set検索日コード] = useState<"1" | "2" | "3" | null>()
  const [, set検索日] = useState<string | null>()
  const [検索日ItemSource, set検索日ItemSource] =
    useState<T検索日ComboboxItem[]>()
  const [検索日From, set検索日From] = useState<string | null | undefined>(
    翌営業日
  )
  const [検索日To, set検索日To] = useState<string | null | undefined>(翌営業日)

  const [荷主コード, set荷主コード] = useState<string>()
  const [荷主名, set荷主名] = useState<string>()

  const [表紙分割ID, set表紙分割ID] = useState<number | null>()
  const [表紙分割ItemSource, set表紙分割ItemSource] = useState<T表紙分割[]>()

  const [請求内訳ID, set請求内訳ID] = useState<number | null>()
  const [請求内訳ItemSource, set請求内訳ItemSource] = useState<T請求内訳[]>()

  const [品コード, set品コード] = useState<string>()
  const [品名, set品名] = useState<string>()

  //２列目
  const [受注部所コード, set受注部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  const [荷主依頼番号, set荷主依頼番号] = useState<string>()

  const [積地コード, set積地コード] = useState<string>()
  const [積地地名, set積地地名] = useState<string>()
  const [積地社名, set積地社名] = useState<string>()
  const [卸地コード, set卸地コード] = useState<string>()
  const [卸地地名, set卸地地名] = useState<string>()
  const [卸地社名, set卸地社名] = useState<string>()

  //３列目
  const [付替区分コード, set付替区分コード] = useState<string | null>()
  const [車番, set車番] = useState<string>()
  const [車種区分コード, set車種区分コード] = useState<string | null>()
  const [乗務員コード, set乗務員コード] = useState<string>()
  const [乗務員, set乗務員] = useState<string>()

  const [運行部所コード, set運行部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)
  const [配車状態区分コード, set配車状態区分コード] = useState<string | null>()
  const [請求額確認区分コード, set請求額確認区分コード] = useState<
    string | null
  >()

  const [受注配車番号, set受注配車番号] = useState("")

  const [傭車会社あり対象フラグ, set傭車会社あり対象フラグ] = useState(0)

  const [表示順区分コード, set表示順区分コード] = useState<string | null>()

  const [isInvalid受注部所コード, setIsInvalid受注部所コード] = useState(false)
  //#endregion

  //#region [comboboxState]
  // 検索日
  const [検索日ComboBox, set検索日ComboBox] = useState<TWijmoComboBox<
    T検索日ComboboxItem["value"],
    T検索日ComboboxItem
  > | null>(null)
  const [検索日IsLoadEnded, set検索日IsLoadEnded] = useState<boolean>(false)

  // 表紙分割
  const [表紙分割ComboBox, set表紙分割ComboBox] = useState<TWijmoComboBox<
    T表紙分割["荷主請求ID"],
    T表紙分割
  > | null>(null)
  const [表紙分割IsLoadEnded, set表紙分割IsLoadEnded] = useState<boolean>(false)
  // 請求内訳
  const [請求内訳ComboBox, set請求内訳ComboBox] = useState<TWijmoComboBox<
    T請求内訳["荷主請求内訳ID"],
    T請求内訳
  > | null>(null)
  const [請求内訳IsLoadEnded, set請求内訳IsLoadEnded] = useState<boolean>(false)
  // 受注部所
  const [受注部所ComboBox, set受注部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [受注部所isLoadEnded, set受注部所isLoadEnded] = useState<boolean>(false)

  // 付替区分
  const [付替区分ComboBox, set付替区分ComboBox] = useState<TWijmoComboBox<
    string,
    T区分マスタ
  > | null>(null)
  const [付替区分isLoadEnded, set付替区分isLoadEnded] = useState<boolean>(false)
  // 車種
  const [車種区分ComboBox, set車種区分ComboBox] = useState<TWijmoComboBox<
    string,
    T区分マスタ
  > | null>(null)
  const [車種区分isLoadEnded, set車種区分isLoadEnded] = useState<boolean>(false)
  // 運行場所
  const [運行部所ComboBox, set運行部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [運行部所isLoadEnded, set運行部所isLoadEnded] = useState<boolean>(false)

  // 配車状態
  const [配車状態区分ComboBox, set配車状態区分ComboBox] =
    useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [配車状態区分isLoadEnded, set配車状態区分isLoadEnded] =
    useState<boolean>(false)
  // 請求額確認
  const [請求額確認区分ComboBox, set請求額確認区分ComboBox] =
    useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [請求額確認区分isLoadEnded, set請求額確認区分isLoadEnded] =
    useState<boolean>(false)
  // 表示順
  const [表示順区分ComboBox, set表示順区分ComboBox] = useState<TWijmoComboBox<
    string,
    T区分マスタ
  > | null>(null)
  const [表示順区分isLoadEnded, set表示順区分isLoadEnded] =
    useState<boolean>(false)

  //#region grid操作
  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)
  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [comboBoxDataInitialized, setComboBoxDataInitialized] = useState(false)
  // 荷主検索用モーダル
  const [is荷主検索Modal, setIs荷主検索Modal] = useState<boolean>(false)

  //#endregion

  //#endregion

  //#region [effect]
  // 初期設定
  useEffect(() => {
    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
      setInit荷主請求内訳(),
    ]).then(([部所ListRes, 区分マスタRes]) => {
      set検索日ItemSource(検索日)
      set部所ItemSource(部所ListRes.data)
      set区分ItemSource(区分マスタRes.data)
      区分マスタRes &&
        set配車状態区分ItemSource(
          区分マスタRes.data.filter((d) => d.区分コード.length === 1)
        )

      setComboBoxDataInitialized(true)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && 受注部所isLoadEnded && comboBoxDataInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        restoreSearch()
      } else {
        set受注部所コード(userInfo.部所コード)
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, 受注部所isLoadEnded, comboBoxDataInitialized])

  //#endregion

  //#region [method]

  /**
   * ページ初期状態でクエリに表紙名もしくは荷主請求内訳があった時に一覧を取得します。
   */
  const setInit荷主請求内訳 = async () => {
    if (location.search == null || location.search === "") return

    const query: Partial<
      TZyutyuHaisyaListGetReq<"1"> &
        TZyutyuHaisyaListGetReq<"2"> &
        TZyutyuHaisyaListGetReq<"3">
    > = queryString.parse(location.search)
    if (query == null) return

    // 表紙名と請求内訳からlistを取得し、埋め込む
    if (query.荷主コード) {
      const 表紙分割Res = await new NinusiSeikyuService().getList({
        荷主コード: query.荷主コード,
      })

      if (表紙分割Res.data && 表紙分割Res.data.length > 0) {
        set表紙分割ItemSource([...表紙分割Res.data])
      }
    }
    if (query.表紙分割ID) {
      const 荷主請求内訳Res = await new NinusiSeikyuService().getListUchiwake({
        荷主請求Id: query.表紙分割ID,
      })
      if (荷主請求内訳Res.data && 荷主請求内訳Res.data.length > 0) {
        set請求内訳ItemSource([...荷主請求内訳Res.data])
      }
    }
  }

  const restoreSearch = async () => {
    let querySearchCondition:
      | TZyutyuHaisyaListGetReq<T検索日種別コード>
      | undefined = undefined

    // 遷移してきた際のクエリパラメータで検索条件を生成
    querySearchCondition = await queryParse()
    // 再検索
    await search(querySearchCondition)

    dispatch(画面ロック解除())

    // リストア中フラグON
    setIsRestoreSearching(true)
  }

  /**
   * URL Queryを解析
   */
  const queryParse = async () => {
    const query: Partial<
      TZyutyuHaisyaListGetReq<"1"> &
        TZyutyuHaisyaListGetReq<"2"> &
        TZyutyuHaisyaListGetReq<"3">
    > = queryString.parse(location.search)
    set荷主コード(query.荷主コード)
    set荷主名(query.荷主名)
    // 検索日変更用
    if (query.積日From || query.積日To) {
      set検索日コード(e検索日種別.積日)
      set検索日From(query.積日From)
      set検索日To(query.積日To)
    } else if (query.卸日From || query.卸日To) {
      set検索日コード(e検索日種別.卸日)
      set検索日From(query.卸日From)
      set検索日To(query.卸日To)
    } else if (query.請求計上日From || query.請求計上日To) {
      set検索日コード(e検索日種別.請求計上日)
      set検索日From(query.請求計上日From)
      set検索日To(query.請求計上日To)
    }
    set受注部所コード(query.受注部所コード ?? userInfo.部所コード ?? "")
    set運行部所コード(query.運行部所コード ?? "")
    set付替区分コード(query.運行部所コード ?? "")
    set配車状態区分コード(query.配車状態区分コード ?? "")
    set荷主コード(query.荷主コード ?? "")
    set荷主名(query.荷主名 ?? "")

    const query表紙分割ID = query?.表紙分割ID?.toString() ?? ("" as string)
    query表紙分割ID !== "" && set表紙分割ID(parseInt(query表紙分割ID))
    const query請求内訳ID = query?.請求内訳ID?.toString() ?? ("" as string)
    query請求内訳ID !== "" && set請求内訳ID(parseInt(query請求内訳ID))

    set積地コード(query.積地コード ?? "")
    set積地社名(query.積地社名 ?? "")
    set積地地名(query.積地地名 ?? "")

    set卸地コード(query.卸地コード ?? "")
    set卸地社名(query.卸地社名 ?? "")
    set卸地地名(query.卸地地名 ?? "")

    set車番(query.車番 ?? "")
    set車種区分コード(query.車種区分コード ?? "")
    set乗務員コード(query.乗務員コード ?? "")
    set乗務員(query.乗務員 ?? "")
    set傭車会社あり対象フラグ(
      query.傭車会社あり対象フラグ != null &&
        query.傭車会社あり対象フラグ.toString() === "1"
        ? 1
        : 0
    )
    set品名(query.品名 ?? "")
    set品コード(query.品コード ?? "")

    set荷主依頼番号(query.荷主依頼番号 ?? "")
    set請求額確認区分コード(query.請求額確認区分コード ?? "")

    set表示順区分コード(query.表示順区分コード)
    set受注配車番号(
      query.受注伝票番号
        ? `${query.受注伝票番号}${query.受注枝番 ? `-${query.受注枝番}` : ""}`
        : ""
    )
    return query as TZyutyuHaisyaListGetReq<T検索日種別コード>
  }

  /**
   * 検索
   */
  const search = async (
    searchCondition?: TZyutyuHaisyaListGetReq<T検索日種別コード>
  ) => {
    //遷移の制御確認
    if (isPrompt.current) {
      if (window.confirm(CONSTANT.MESSAGES.BROWSER_BACK)) {
        isPrompt.current = false
      } else {
        return
      }
    }
    setIsSearching(true)
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition:
      | TZyutyuHaisyaListGetReq<T検索日種別コード>
      | undefined
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    if (currentSearchCondition == null) return
    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    // TODO:検索処理導入
    try {
      const service = new ZyutyuHaisyaService()
      const res = await service.getList(currentSearchCondition)
      const newSearchResult = [...res.data] as typeof searchResult

      // 分割受注配車の情報を取得
      if (newSearchResult && newSearchResult.length > 0) {
        const IdList = newSearchResult.map((d) => d.受注配車ID)
        const 分割情報Res =
          await new HaisyaService().getBunkatuZyutyuHaisyaList({
            IdList,
          })
        if (分割情報Res.data && 分割情報Res.data.length > 0) {
          // 取得した分割情報を対応する受注配車に付与
          newSearchResult.forEach((data) => {
            const 分割情報 = 分割情報Res.data.find(
              (分割) => 分割.受注配車ID === data.受注配車ID
            )
            if (分割情報) {
              data.分割情報 = 分割情報
            }
          })
        }
      }
      setSearchResult(newSearchResult)
      setPreSearchCondition(currentSearchCondition)
      set検索結果受注部所コード(currentSearchCondition.受注部所コード)
      // QueryStringに検索条件を反映
      pageHelper.pushQuery(history, location, currentSearchCondition)
    } catch (error) {
      dispatch(setAlerts(error))
      setIsSearching(false)
    } finally {
    }
  }

  /**
   * 検索条件作成
   * @param queryString
   */
  const createSearchCondition = (
    queryString?: string
  ): TZyutyuHaisyaListGetReq<T検索日種別コード> | undefined => {
    // 受注配車番号を受注伝票番号と受注枝番に変換
    const [受注伝票番号, 受注枝番] = 受注配車番号.split("-")

    let 共通検索条件: TZyutyuHaisyaListGetReqInner = {
      受注伝票番号,
      受注枝番,
      検索日From: 検索日From ?? undefined,
      検索日To: 検索日To ?? undefined,
      受注部所コード: 受注部所コード ?? "",
      運行部所コード: 運行部所コード ?? undefined,
      請求内訳ID:
        請求内訳ID != null && 請求内訳ID !== 0 ? 請求内訳ID : undefined,
      付替区分コード: 付替区分コード ?? undefined,
      配車状態区分コード: 配車状態区分コード ?? undefined,
      荷主コード,
      荷主名,
      表紙分割ID:
        表紙分割ID != null && 表紙分割ID !== 0 ? 表紙分割ID : undefined,
      積地コード,
      積地社名,
      積地地名,
      車番,
      車種区分コード: 車種区分コード ?? undefined,
      乗務員コード,
      乗務員,
      傭車会社あり対象フラグ,
      品コード,
      品名,
      卸地コード,
      卸地社名,
      卸地地名,
      荷主依頼番号,
      請求額確認区分コード: 請求額確認区分コード ?? undefined,
      表示順区分コード: 表示順区分コード ?? undefined,
    }
    switch (検索日コード) {
      case e検索日種別.積日:
        let 検索条件1: TZyutyuHaisyaListGetReq<"1"> = {
          ...共通検索条件,
          積日From: 検索日From ?? "",
          積日To: 検索日To ?? "",
        }
        return 検索条件1
      case e検索日種別.卸日:
        let 検索条件2: TZyutyuHaisyaListGetReq<"2"> = {
          ...共通検索条件,
          卸日From: 検索日From ?? "",
          卸日To: 検索日To ?? "",
        }
        return 検索条件2
      case e検索日種別.請求計上日:
        let 検索条件3: TZyutyuHaisyaListGetReq<"3"> = {
          ...共通検索条件,
          請求計上日From: 検索日From ?? "",
          請求計上日To: 検索日To ?? "",
        }
        return 検索条件3
      default:
        break
    }
  }

  /**
   * 表示用検索条件作成
   * @param queryString
   */
  const createDisplaySearchCondition = (
    searchCondition: TZyutyuHaisyaListGetReq<T検索日種別コード>
  ): T表示用検索条件<T検索日種別コード> | undefined => {
    let 表示用検索条件共通部: T表示用検索条件共通部 = {
      受注部所: 部所ItemSource?.find(
        (i) => i.部所コード === searchCondition.受注部所コード
      )?.部所名,
      運行部所: 部所ItemSource?.find(
        (i) => i.部所コード === searchCondition.運行部所コード
      )?.部所名,
      付替区分: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.付替区分コード &&
          i.分類コード === 区分分類コード.受注配車_請求支払.付替区分
      )?.名称1,
      配車状態区分: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.配車状態区分コード &&
          i.分類コード === 区分分類コード.受注配車_請求支払.配車状態区分
      )?.名称1,
      受注No: searchCondition.受注伝票番号
        ? `${searchCondition.受注伝票番号}${
            searchCondition.受注枝番 ? `-${searchCondition.受注枝番}` : ""
          }`
        : undefined,
      荷主コード: searchCondition.荷主コード,
      荷主名: searchCondition.荷主名,
      表紙分割: 表紙分割ItemSource?.find(
        (i) =>
          i.荷主請求ID.toString() === searchCondition?.表紙分割ID?.toString()
      )?.表紙名,
      請求内訳: 請求内訳ItemSource?.find(
        (i) =>
          i.荷主請求内訳ID.toString() ===
          searchCondition?.請求内訳ID?.toString()
      )?.請求内訳名,
      積地コード: searchCondition.積地コード,
      積地社名: searchCondition.積地社名,
      積地地名: searchCondition.積地地名,
      卸地コード: searchCondition.卸地コード,
      卸地社名: searchCondition.卸地社名,
      卸地地名: searchCondition.卸地地名,
      品コード: searchCondition.品コード,
      品名: searchCondition.品名,
      車番: searchCondition.車番,
      車種区分: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.車種区分コード &&
          i.分類コード === 区分分類コード.車輌.車種区分
      )?.名称1,
      乗務員: searchCondition.乗務員,
      傭車あり: searchCondition.傭車会社あり対象フラグ === 1,
      荷主依頼番号: searchCondition.荷主依頼番号,
      請求額確認区分: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.請求額確認区分コード &&
          i.分類コード === 区分分類コード.受注配車_請求支払.請求支払確認区分
      )?.名称1,
      表示順区分: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.表示順区分コード &&
          i.分類コード ===
            区分分類コード.受注配車_請求支払.受注配車入力表示順区分
      )?.名称1,
    }
    switch (検索日コード) {
      case e検索日種別.積日: {
        const sc = searchCondition as TZyutyuHaisyaListGetReq<"1">
        let 検索条件: T表示用検索条件<"1"> = {
          積日From: dateUtil.format(sc.積日From) ?? "",
          積日To: dateUtil.format(sc.積日To) ?? "",
          ...表示用検索条件共通部,
        }
        return 検索条件
      }
      case e検索日種別.卸日: {
        const sc = searchCondition as TZyutyuHaisyaListGetReq<"2">
        let 検索条件: T表示用検索条件<"2"> = {
          卸日From: dateUtil.format(sc.卸日From) ?? "",
          卸日To: dateUtil.format(sc.卸日To) ?? "",
          ...表示用検索条件共通部,
        }
        return 検索条件
      }
      case e検索日種別.請求計上日: {
        const sc = searchCondition as TZyutyuHaisyaListGetReq<"3">
        let 検索条件: T表示用検索条件<"3"> = {
          請求計上日From: dateUtil.format(sc.請求計上日From) ?? "",
          請求計上日To: dateUtil.format(sc.請求計上日To) ?? "",
          ...表示用検索条件共通部,
        }
        return 検索条件
      }
      default:
        break
    }
  }

  /**
   *
   * @param 荷主コード
   * @returns
   */
  const set表紙 = async (荷主コード: string) => {
    try {
      if (荷主コード == null || 荷主コード === "") {
        set表紙分割ItemSource([])
        set請求内訳ItemSource([])
        return
      }
      const 荷主res = await new NinusiService().getList({
        荷主コード: 荷主コード !== "" ? 荷主コード : undefined,
        完全一致フラグ: true,
      })
      if (荷主res.data == null || 荷主res.data.length <= 0) {
        set表紙分割ItemSource([])
        set請求内訳ItemSource([])
        return
      }
      const 荷主 = 荷主res.data[0]
      set荷主コード(荷主.荷主コード)
      set荷主名(荷主.荷主略称1)
      if (荷主 != null) {
        const ninusiSeikyuService = new NinusiSeikyuService()
        const 荷主請求res = await ninusiSeikyuService.getList({
          荷主Id: 荷主.荷主ID,
        })
        if (荷主請求res && 荷主請求res.data.length > 0) {
          set表紙分割ItemSource([...荷主請求res.data])
          set請求内訳ItemSource([])
        } else {
          set表紙分割ItemSource([])
          set請求内訳ItemSource([])
        }
      } else {
        set表紙分割ItemSource([])
        set請求内訳ItemSource([])
      }
    } catch (error) {
      dispatch(setAlerts(error))
    }
  }

  //#endregion
  return (
    <>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">受注配車一覧</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card className="w-150rem">
              {/* CardHeaderをアコーディオン化 */}
              <Card.Header
                onClick={() => setAccordionController(!accordionController)}
                aria-controls="collapse-search-card-body"
                aria-expanded={accordionController}>
                <FontAwesomeIcon
                  icon={accordionController ? faChevronDown : faChevronUp}
                  size={"1x"}
                />
                検索条件
              </Card.Header>
              <Collapse in={accordionController}>
                <Card.Body id="collapse-search-card-body">
                  <Form>
                    <Container fluid className="contents-search-main">
                      <Row>
                        <Col>
                          <div className="search-condition-table">
                            <div className="search-condition-row">
                              <div className="w-10rem">
                                <ComboBox.Default
                                  placeholder="検索日"
                                  itemsSource={検索日ItemSource}
                                  isLoadEnded={検索日IsLoadEnded}
                                  selectedValue={検索日コード}
                                  isRequired={true}
                                  setSelectedValue={(v) => {
                                    set検索日コード(v)
                                  }}
                                  setText={set検索日}
                                  setIsLoadEnded={set検索日IsLoadEnded}
                                  ComboBox={検索日ComboBox}
                                  setComboBox={
                                    set検索日ComboBox
                                  }></ComboBox.Default>
                              </div>
                              <div className="w-13rem">
                                <DateInput
                                  id="検索日from"
                                  placeholder="検索日From"
                                  isRequired={true}
                                  has1DayButton={true}
                                  showHoliday={true}
                                  value={検索日From}
                                  defaultValue={翌営業日}
                                  setValue={(v) => {
                                    set検索日From(v)
                                  }}></DateInput>
                              </div>
                              <div className="w-13rem">
                                <DateInput
                                  id="検索日To"
                                  placeholder="検索日To"
                                  value={検索日To}
                                  isRequired={true}
                                  has1DayButton={true}
                                  showHoliday={true}
                                  defaultValue={翌営業日}
                                  setValue={(v) => {
                                    set検索日To(v)
                                  }}></DateInput>
                              </div>
                              <div className=""></div>
                              <ComboBox.Busyo
                                placeholder="受注部所"
                                isLoadEnded={受注部所isLoadEnded}
                                setIsLoadEnded={set受注部所isLoadEnded}
                                className={
                                  isInvalid受注部所コード
                                    ? "busyo-combo-box is-error"
                                    : "busyo-combo-box"
                                }
                                isAllSelect={false}
                                isEmpty={true}
                                isRequired={true}
                                itemsSource={部所ItemSource}
                                selectedValue={受注部所コード}
                                listFilter={(d) => d.運行部所フラグ === 1}
                                setSelectedValue={(v) => {
                                  set受注部所コード(v)
                                }}
                                ComboBox={受注部所ComboBox}
                                setComboBox={
                                  set受注部所ComboBox
                                }></ComboBox.Busyo>
                              <div className="w-10rem">
                                <ComboBox.Kubun
                                  placeholder="付替区分"
                                  分類コード={
                                    区分分類コード.受注配車_請求支払.付替区分
                                  }
                                  isAllSelect={true}
                                  isRequired={false}
                                  itemsSource={区分ItemSource}
                                  isLoadEnded={付替区分isLoadEnded}
                                  setIsLoadEnded={set付替区分isLoadEnded}
                                  selectedValue={付替区分コード}
                                  setSelectedValue={(v) => {
                                    set付替区分コード(v)
                                  }}
                                  ComboBox={付替区分ComboBox}
                                  setComboBox={
                                    set付替区分ComboBox
                                  }></ComboBox.Kubun>
                              </div>
                              <ComboBox.Busyo
                                placeholder="運行部所"
                                isLoadEnded={運行部所isLoadEnded}
                                setIsLoadEnded={set運行部所isLoadEnded}
                                isAllSelect={true}
                                isRequired={false}
                                itemsSource={部所ItemSource}
                                selectedValue={運行部所コード}
                                listFilter={(d) => d.運行部所フラグ === 1}
                                setSelectedValue={(v) => {
                                  set運行部所コード(v)
                                }}
                                ComboBox={運行部所ComboBox}
                                setComboBox={
                                  set運行部所ComboBox
                                }></ComboBox.Busyo>

                              <ComboBox.Kubun
                                placeholder="配車状態"
                                分類コード={
                                  区分分類コード.受注配車_請求支払.配車状態区分
                                }
                                itemsSource={配車状態区分ItemSource}
                                isLoadEnded={配車状態区分isLoadEnded}
                                setIsLoadEnded={set配車状態区分isLoadEnded}
                                isAllSelect={true}
                                isRequired={false}
                                selectedValue={配車状態区分コード}
                                setSelectedValue={(v) => {
                                  set配車状態区分コード(v)
                                }}
                                ComboBox={配車状態区分ComboBox}
                                setComboBox={
                                  set配車状態区分ComboBox
                                }></ComboBox.Kubun>
                              <div className="input-group">
                                <TextInput
                                  style={{ width: "12rem" }}
                                  id="受注No"
                                  name="受注No"
                                  value={受注配車番号}
                                  setValue={(v) => {
                                    set受注配車番号(v)
                                  }}
                                  placeholder="受注No"
                                />
                              </div>
                            </div>
                            <div className="search-condition-row">
                              <div className="input-group">
                                <TextInput
                                  style={{ width: "6rem" }}
                                  id="荷主コード"
                                  name="荷主コード"
                                  value={荷主コード}
                                  onBlur={async (e) => {
                                    const v = e.currentTarget.value
                                    set表紙(v)
                                  }}
                                  setValue={(v) => {
                                    set荷主コード(v)
                                  }}
                                  maxLength={5}
                                  placeholder="荷主CD"
                                />
                                <button
                                  type="button"
                                  className="icon-button"
                                  onClick={(e) => {
                                    e.preventDefault()
                                    setIs荷主検索Modal(true)
                                  }}>
                                  <FontAwesomeIcon
                                    className="icon-button-inner"
                                    icon={faSearch}></FontAwesomeIcon>
                                </button>
                                <TextInput
                                  style={{ width: "16.1rem" }}
                                  id="荷主名"
                                  name="荷主名"
                                  value={荷主名}
                                  setValue={set荷主名}
                                  maxLength={100}
                                  placeholder="荷主名"
                                />
                              </div>
                              <ComboBox.HyosiBunkatu
                                placeholder="表紙名"
                                isReadOnly={
                                  表紙分割ItemSource == null ||
                                  表紙分割ItemSource.length <= 0
                                    ? true
                                    : false
                                }
                                isAllSelect={true}
                                itemsSource={表紙分割ItemSource}
                                isLoadEnded={表紙分割IsLoadEnded}
                                setIsLoadEnded={set表紙分割IsLoadEnded}
                                lostFocus={(control) => {
                                  if (control.selectedValue == null) return

                                  const ninusiSeikyuService =
                                    new NinusiSeikyuService()
                                  ninusiSeikyuService
                                    .getListUchiwake({
                                      荷主請求Id: control.selectedValue,
                                    })
                                    .then((res) => {
                                      res.data &&
                                        res.data.length > 0 &&
                                        set請求内訳ItemSource([...res.data])
                                    })
                                }}
                                setSelectedValue={(v) => {
                                  set表紙分割ID(v)
                                }}
                                selectedValue={表紙分割ID}
                                ComboBox={表紙分割ComboBox}
                                setComboBox={
                                  set表紙分割ComboBox
                                }></ComboBox.HyosiBunkatu>
                              <div className="input-group">
                                <TextInput
                                  style={{ width: "7rem" }}
                                  id="積地コード"
                                  name="積地コード"
                                  placeholder="積地CD"
                                  value={積地コード}
                                  maxLength={
                                    VALIDATE_CONSTANT.LENGTH.積卸先コード
                                  }
                                  setValue={(v) => {
                                    set積地コード(v)
                                  }}></TextInput>
                                <TextInput
                                  id="積地"
                                  name="積地社名"
                                  value={積地社名}
                                  setValue={set積地社名}
                                  maxLength={100}
                                  placeholder="積地社名"
                                />
                                <TextInput
                                  id="積地"
                                  name="積地地名"
                                  value={積地地名}
                                  setValue={set積地地名}
                                  maxLength={100}
                                  placeholder="積地地名"
                                />
                              </div>
                              {/* TODO: 本来はasyncTypeahead? */}
                              <div className="input-group">
                                <TextInput
                                  style={{ width: "5rem" }}
                                  id="車番"
                                  name="車番"
                                  value={車番}
                                  setValue={set車番}
                                  maxLength={4}
                                  placeholder="車番"
                                />
                                <div className="w-18rem">
                                  <ComboBox.Kubun
                                    placeholder="車種区分"
                                    分類コード={区分分類コード.車輌.車種区分}
                                    isAllSelect={true}
                                    isRequired={false}
                                    itemsSource={区分ItemSource}
                                    isLoadEnded={車種区分isLoadEnded}
                                    setIsLoadEnded={set車種区分isLoadEnded}
                                    selectedValue={車種区分コード}
                                    setSelectedValue={(v) => {
                                      set車種区分コード(v)
                                    }}
                                    ComboBox={車種区分ComboBox}
                                    setComboBox={
                                      set車種区分ComboBox
                                    }></ComboBox.Kubun>
                                </div>
                              </div>
                              <div className="input-group">
                                <TextInput
                                  style={{ width: "5rem" }}
                                  id="乗務員コード"
                                  name="乗務員コード"
                                  value={乗務員コード}
                                  setValue={set乗務員コード}
                                  maxLength={4}
                                  placeholder="社員CD"
                                />
                                <TextInput
                                  style={{ width: "12rem" }}
                                  id="乗務員"
                                  name="乗務員"
                                  value={乗務員}
                                  setValue={set乗務員}
                                  maxLength={100}
                                  placeholder="乗務員"
                                />
                              </div>
                              <span className={"align-middle"}>
                                <CheckInput
                                  id="傭車"
                                  type={"switch"}
                                  label={"傭車"}
                                  setValue={(v) => set傭車会社あり対象フラグ(v)}
                                  value={傭車会社あり対象フラグ}
                                />
                              </span>
                            </div>
                            <div className="search-condition-row">
                              <div className="input-group">
                                <TextInput
                                  style={{ width: "6rem" }}
                                  id="品コード"
                                  name="品コード"
                                  value={品コード}
                                  setValue={(v) => {
                                    set品コード(v)
                                  }}
                                  maxLength={5}
                                  placeholder="品名CD"
                                />
                                <TextInput
                                  style={{ width: "18rem" }}
                                  id="品名"
                                  name="品名"
                                  value={品名}
                                  setValue={set品名}
                                  maxLength={100}
                                  placeholder="品名"
                                />
                              </div>
                              <ComboBox.SeikyuUtiwake
                                placeholder="請求内訳"
                                isReadOnly={
                                  請求内訳ItemSource == null ||
                                  請求内訳ItemSource.length <= 0
                                    ? true
                                    : false
                                }
                                isAllSelect={true}
                                itemsSource={請求内訳ItemSource}
                                isLoadEnded={請求内訳IsLoadEnded}
                                setIsLoadEnded={set請求内訳IsLoadEnded}
                                setSelectedValue={(v) => {
                                  set請求内訳ID(v)
                                }}
                                selectedValue={請求内訳ID}
                                ComboBox={請求内訳ComboBox}
                                setComboBox={
                                  set請求内訳ComboBox
                                }></ComboBox.SeikyuUtiwake>
                              <div className="input-group">
                                <TextInput
                                  style={{ width: "7rem" }}
                                  id="卸地コード"
                                  name="卸地コード"
                                  placeholder="卸地CD"
                                  value={卸地コード}
                                  maxLength={
                                    VALIDATE_CONSTANT.LENGTH.積卸先コード
                                  }
                                  setValue={(v) => {
                                    set卸地コード(v)
                                  }}></TextInput>
                                <TextInput
                                  id="卸地"
                                  name="卸地社名"
                                  value={卸地社名}
                                  setValue={set卸地社名}
                                  maxLength={100}
                                  placeholder="卸地社名"
                                />
                                <TextInput
                                  id="卸地"
                                  name="卸地地名"
                                  value={卸地地名}
                                  setValue={set卸地地名}
                                  maxLength={100}
                                  placeholder="卸地地名"
                                />
                              </div>
                              <div className="w-12rem">
                                <TextInput
                                  id="荷主依頼No"
                                  name="荷主依頼No"
                                  value={荷主依頼番号}
                                  setValue={set荷主依頼番号}
                                  maxLength={100}
                                  placeholder="荷主依頼No"
                                />
                              </div>
                              <div className="w-10rem">
                                <ComboBox.Kubun
                                  placeholder="請求額確認"
                                  分類コード={
                                    区分分類コード.受注配車_請求支払
                                      .請求支払確認区分
                                  }
                                  itemsSource={区分ItemSource}
                                  isLoadEnded={請求額確認区分isLoadEnded}
                                  isAllSelect={true}
                                  isRequired={false}
                                  setIsLoadEnded={set請求額確認区分isLoadEnded}
                                  selectedValue={請求額確認区分コード}
                                  setSelectedValue={(v) => {
                                    set請求額確認区分コード(v)
                                  }}
                                  ComboBox={請求額確認区分ComboBox}
                                  setComboBox={
                                    set請求額確認区分ComboBox
                                  }></ComboBox.Kubun>
                              </div>
                              <div className="w-20rem">
                                <ComboBox.Kubun
                                  placeholder="表示順"
                                  分類コード={
                                    区分分類コード.受注配車_請求支払
                                      .受注配車入力表示順区分
                                  }
                                  itemsSource={区分ItemSource}
                                  isLoadEnded={表示順区分isLoadEnded}
                                  isAllSelect={false}
                                  isRequired={false}
                                  setIsLoadEnded={set表示順区分isLoadEnded}
                                  selectedValue={表示順区分コード}
                                  setSelectedValue={(v) => {
                                    set表示順区分コード(v)
                                  }}
                                  ComboBox={表示順区分ComboBox}
                                  setComboBox={
                                    set表示順区分ComboBox
                                  }></ComboBox.Kubun>
                              </div>
                            </div>
                            <Button
                              type="submit"
                              variant="primary"
                              disabled={isSearching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                // 受注部所、未選択の場合検索させない
                                if (
                                  受注部所コード == null ||
                                  受注部所コード === ""
                                ) {
                                  setIsInvalid受注部所コード(true)
                                  dispatch(
                                    setWarningAlerts([
                                      "受注部所を選択してください",
                                    ])
                                  )
                                  return
                                } else {
                                  setIsInvalid受注部所コード(false)
                                }
                                search()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </Form>
                </Card.Body>
              </Collapse>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索結果カード */}
            <Card>
              <Spinner searching={isSearching}></Spinner>
              <Card.Body>
                <Row>
                  <Col xs={12}>
                    {/* 検索条件表示コンポーネント */}
                    <DisplaySearchConditionLabel
                      displaySearchCondition={displaySearchCondition}
                    />
                  </Col>
                </Row>
                <ZyutyuHaisyaListProvider
                  isSearching={{ state: isSearching, setState: setIsSearching }}
                  isRestoreSearching={{
                    state: isRestoreSearching,
                    setState: setIsRestoreSearching,
                  }}
                  SearchResult={searchResult}
                  gridInitialized={{
                    state: gridInitialized,
                    setState: setGridInitialized,
                  }}
                  searchCondition={preSearchCondition}
                  search={search}
                  zyutyuBusyo={検索結果受注部所コード}
                  isPrompt={isPrompt}>
                  <ZyutyuHaisyaListGrid gridId={gridId}></ZyutyuHaisyaListGrid>
                </ZyutyuHaisyaListProvider>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      {/* 荷主検索 */}
      <NinusiSearchModal
        size="lg"
        setIsShow={setIs荷主検索Modal}
        isShow={is荷主検索Modal}
        setNinusi={(荷主) => {
          set表紙(荷主.荷主コード)
        }}></NinusiSearchModal>
    </>
  )
}

export default ZyutyuHaisyaList
